import { render, staticRenderFns } from "./FacebookCallback.vue?vue&type=template&id=3ebd4546&"
import script from "./FacebookCallback.vue?vue&type=script&lang=js&"
export * from "./FacebookCallback.vue?vue&type=script&lang=js&"
import style0 from "./FacebookCallback.vue?vue&type=style&index=0&id=3ebd4546&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports